// extracted by mini-css-extract-plugin
export default {"container":"IW-z","starLabel":"JW-z"};